<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      data-name="합치기 337"
      d="M5.47 16.248h1.249a1.25 1.25 0 0 0 2.5 0h1.252a2.5 2.5 0 0 1-5 0zM.232 13.587a2.416 2.416 0 0 1 .325-2.576 6.932 6.932 0 0 0 .554-.927 7.88 7.88 0 0 0 .753-3.031 5.935 5.935 0 0 1 5.48-5.767V0H8.6v1.284a5.943 5.943 0 0 1 5.489 5.775 7.812 7.812 0 0 0 .779 3.07 5.978 5.978 0 0 0 .579.952 2.424 2.424 0 0 1 .253 2.529 2.571 2.571 0 0 1-2.178 1.413H2.459a2.577 2.577 0 0 1-2.227-1.436zM7.446 2.531A4.69 4.69 0 0 0 3.112 7.1a9.1 9.1 0 0 1-.875 3.529 7.711 7.711 0 0 1-.695 1.152 1.178 1.178 0 0 0-.184 1.269 1.311 1.311 0 0 0 1.123.727h11.008a1.306 1.306 0 0 0 1.088-.721 1.161 1.161 0 0 0-.132-1.217 7.745 7.745 0 0 1-.7-1.157 9.171 9.171 0 0 1-.9-3.575 4.7 4.7 0 0 0-4.366-4.586z"
      transform="translate(2.03 .001)"
      style="fill:#585858"
    />
    <path data-name="사각형 147018" style="fill:none" d="M0 0h20v20H0z" />
  </svg>
</template>

<script>
export default {
  name: 'BellIcon',
};
</script>
